import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#F0EDEB]" data-id="element-150">
      <div className="max-w-2xl mx-auto px-6" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-152">
          <p className="text-lg md:text-xl leading-relaxed mb-8 text-[#6B7280]" data-id="element-153">
            <span className="font-bold text-[#2D2D2D] text-2xl block mb-2" data-id="element-154">
              No es la falta de amor. Es el agotamiento.
            </span>
            Estás en un ciclo donde cada discusión por una cuenta vencida o un
            plato sin lavar se convierte en una guerra nuclear. Te vas a dormir
            dándole la espalda a la persona que amas, preguntándote si no sería
            más fácil estar solo.
          </p>

          <p className="text-lg md:text-xl leading-relaxed mb-10 text-[#6B7280]" data-id="element-155">
            El problema es que tu sistema nervioso está en{' '}
            <span className="text-[#722F37] font-semibold" data-id="element-156">
              modo supervivencia
            </span>
            . En Argentina, el contexto externo es un ruido blanco de ansiedad
            que drena tu paciencia. Cuando llegas a casa, no tienes nada más
            para dar, y tu pareja se convierte, sin querer, en el enemigo.
          </p>

          <div className="bg-[#FFFFFF] p-6 md:p-8 rounded-r-xl border-l-4 border-[#722F37] shadow-lg" data-id="element-157">
            <p className="text-lg md:text-xl leading-relaxed text-[#2D2D2D] font-medium" data-id="element-158">
              Si no separas la "empresa casa" del "vínculo afectivo" hoy, el
              resentimiento se volverá irreversible.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}